module.exports = __webpack_public_path__ + "media/images/emblems/Montpreveyres-coat_of_arms-28a0377839eaa7ab8fb6010c0ed0c15a.svg";